export function shouldRefetchOrderPreview(previousSale, newSale) {
  return previousSale !== newSale && !newSale.from_order_preview
}
